module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C123"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("CHAPTER 1")])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "C124"
  }, [_c('strong', [_vm._v("REVOLUTION")])])]), _c('p', {
    staticClass: "P25"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('strong')]), _c('strong', [_c('a', {
    attrs: {
      "id": "id_2"
    }
  }, [_vm._v("“OXFORD ETHICISTS PROMOTE MDMA")])]), _c('a', {
    attrs: {
      "id": "id_2"
    }
  }, [_vm._v(" to combat divorce.” At least, that’s what a blogger at "), _c('em', [_vm._v("Dose Nation")]), _vm._v(" said we were doing when we first started writing about the chemical enhancement of love and relationships. ")]), _c('a', {
    attrs: {
      "id": "id_5"
    }
  }, [_vm._v("The blogger was referring to an interview we’d done with "), _c('em', [_vm._v("The Atlantic")]), _vm._v(", where we argued that certain psychoactive substances, including MDMA—the key ingredient in the party drug Ecstasy—might help some couples improve their connection if used in the right way. ")]), _c('a', {
    attrs: {
      "id": "id_4"
    }
  }, [_vm._v("The truth is, we were not promoting the use of MDMA outright. We were calling for research into this possibility while exploring its ethical implications for individuals and society. The same aim, bolstered by the latest data and insights from the cutting edge of bioethics, applies to the book in your hands.")])]), _c('a', {
    attrs: {
      "id": "id_4"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_4"
    }
  }, [_vm._v("This time our call for research is more urgent. MDMA, along with psychedelic drugs like psilocybin (from “magic” mushrooms) and even lysergic acid diethylamide (LSD), ")]), _c('a', {
    attrs: {
      "id": "id_7"
    }
  }, [_vm._v("are moving quickly into the center of mainstream medicine. Receptive pieces by hard-nosed journalists and science writers are coming out almost daily. ")]), _c('a', {
    attrs: {
      "id": "id_9"
    }
  }, [_vm._v("In the "), _c('em', [_vm._v("New York Times")]), _vm._v(" alone, there have been articles on the “Promise of Ecstasy for PTSD,” the benefits of “Magic Mushrooms” for depression in cancer patients, and the potential of LSD as a treatment for ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("alcoholism and anxiety. Ten years ago such coverage would have been confined to fringe sources. ")]), _c('a', {
    attrs: {
      "id": "id_6"
    }
  }, [_vm._v("But now that phase 3 clinical trials for some of these drugs are in the pipeline (or already started), with a stream of smaller studies practically flowing out of labs at Imperial College London, Johns Hopkins, and other major institutions, things are starting to change. ")]), _c('a', {
    attrs: {
      "id": "id_8"
    }
  }, [_vm._v("Phrases like “paradigm shift” are beginning to creep into the titles of research reviews on the science of drug-assisted psychotherapy.")])]), _c('a', {
    attrs: {
      "id": "id_8"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_8"
    }
  }, [_vm._v("Our "), _c('em', [_vm._v("Atlantic")]), _vm._v(" interview came out in 2013. ")]), _c('a', {
    attrs: {
      "id": "id_10"
    }
  }, [_vm._v("This was two years after the first pilot study on MDMA for post-traumatic stress disorder (PTSD) made its way to publication. ")]), _c('a', {
    attrs: {
      "id": "id_11"
    }
  }, [_vm._v("PTSD is an often disabling condition that can develop in response to violence, including exposure to killing and bloodshed in warzones. It has been a widespread problem in the military for decades, reaching “epidemic-level heights” with the wars in Iraq and Afghanistan. ")]), _c('a', {
    attrs: {
      "id": "id_12"
    }
  }, [_vm._v("As the "), _c('em', [_vm._v("Washington Post")]), _vm._v(" reports, between 11 and 20 percent of soldiers in these wars suffer from PTSD, which has ")]), _c('a', {
    attrs: {
      "id": "id_13"
    }
  }, [_vm._v("“ravaged lives and broken up marriages.” Trauma affects more than individual survivors. ")]), _c('a', {
    attrs: {
      "id": "id_14"
    }
  }, [_vm._v("It affects friends, family, and romantic partners, including spouses. Some spouses can hardly recognize the person they married, a once-familiar life partner now prone to unpredictable panic attacks, anger, and even physical aggression.")])]), _c('a', {
    attrs: {
      "id": "id_14"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("This raises a simple but important point. Successful treatment of PTSD, by whatever means, can have positive implications for relationships. But this shouldn’t be a side effect or afterthought. Medical research needs to take interpersonal factors, the space "), _c('em', [_vm._v("between")]), _vm._v(" people, into account—from the initial design of studies, to the collection of data, all the way through to the write-up of the final report. In this book, we focus on romantic relationships, but the point holds more generally. Introducing a drug or other medication into the life of an individual also introduces it into the lives of those who love and care for them. Under current treatment norms, the effect on others happens indirectly. But what if it happened directly, with intention? What if the goal was to improve people’s lives along a relational axis? Romantic partnerships might then become a worthwhile focal point when considering certain drug-based interventions.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Of course, relationships themselves can be traumatic. Sometimes this means they should end. But in other cases there may be significant value in trying to restore a broken connection. Especially when the distress is rooted in outside factors, as is often the case with PTSD, romantic partners may be desperate to find a solution that allows them to maintain the relationship. ")]), _c('a', {
    attrs: {
      "id": "id_15"
    }
  }, [_vm._v("Yet with PTSD, unprocessed traumas can be difficult to put into words, much less talk about productively with a partner. This is part of the reason why traditional talk therapy, and even conventional drugs like Zoloft and Paxil, have done so little to stem the tide of symptoms associated with this condition. “If you’re a combat veteran with multiple tours of duty,” says John Krystal, a PTSD specialist and the chair of psychiatry at Yale, “the chance of a good response to these drugs is 1 in 3, maybe lower. ")]), _c('a', {
    attrs: {
      "id": "id_16"
    }
  }, [_vm._v("That’s why there’s so much frustration and interest in finding something that works better.”")])]), _c('a', {
    attrs: {
      "id": "id_16"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_16"
    }
  }, [_vm._v("This brings us to MDMA and why it seems to show such promise: it sidesteps language. ")]), _c('a', {
    attrs: {
      "id": "id_17"
    }
  }, [_vm._v("Current research suggests that MDMA temporarily reduces hair-trigger fear responses by working directly on emotional centers of the brain. ")]), _c('a', {
    attrs: {
      "id": "id_18"
    }
  }, [_vm._v("Objectively, it causes the release of serotonin and other neurotransmitters and keeps them in play in the clefts between synapses. ")]), _c('a', {
    attrs: {
      "id": "id_20"
    }
  }, [_vm._v("Subjectively, as one writer put it, “it imbues users with a deep sense of love and acceptance of themselves and others—the perfect conditions for trauma therapy.” ")]), _c('a', {
    attrs: {
      "id": "id_19"
    }
  }, [_vm._v("Findings from the early MDMA studies bore this out. Over two-thirds of participants suffering from chronic, treatment-resistant PTSD no longer met the criteria for the disorder twelve months later. Standard therapies do not come close to this degree of effectiveness.")])]), _c('a', {
    attrs: {
      "id": "id_19"
    }
  }, [_c('p', {
    staticClass: "C67"
  }, [_vm._v("♥ ♥ ♥")]), _vm._v(" "), _c('p', {
    staticClass: "P25"
  }, [_vm._v("C. J. Hardin is one of the soldiers who has benefited from MDMA-assisted therapy. After three tours in Iraq and Afghanistan, he was numb from the stress and violence. Then his marriage fell apart. Depressed and alone, he retreated to a backwoods cabin in North Carolina. He turned to alcohol to drown his pain. He considered suicide. He tried every available treatment for PTSD, from group therapy to nearly a dozen medications.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("“Nothing worked for me, so I put aside the idea that I could get better,” he told a reporter. “I just pretty much became a hermit in my cabin and never went out.” But MDMA-assisted therapy, he says, “changed my life. It allowed me to see my trauma without fear or hesitation and finally process things and move forward.”")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("C.J. says he saw “a profound difference” in his symptoms after the very first treatment. ")]), _c('a', {
    attrs: {
      "id": "id_21"
    }
  }, [_vm._v("After three sessions of therapy, “my score on the Clinician-Administered PTSD Scale went from 87 to 7 and I no longer qualified for a diagnosis of PTSD.”")])]), _c('a', {
    attrs: {
      "id": "id_21"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_21"
    }
  }, [_vm._v("“We can sometimes see this kind of remarkable improvement in traditional psychotherapy, but it can take years, if it happens at all,” said Dr. Michael C. Mithoefer, the psychiatrist who conducted the early trials, in an interview. ")]), _c('a', {
    attrs: {
      "id": "id_22"
    }
  }, [_vm._v("“We think it works as a catalyst that speeds the natural healing process.”")])]), _c('a', {
    attrs: {
      "id": "id_22"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("What about C.J.’s relationship? By the time he got his life back, it was too late for his marriage. There is no way of knowing how things might have gone if he’d found an effective treatment earlier. Maybe his marriage needed to end. Maybe it could have been saved and gone on to blossom. The only way to answer such questions is to ask them in advance.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_22"
    }
  }, [_vm._v("Dr. Michael Mithoefer is aware of the need for such research. With his wife, nurse Ann Mithoefer, he has started a tentative program looking into MDMA-enhanced psychotherapy for couples where one of the partners has PTSD. As of late 2017, they had worked with three married couples. A tiny sample to start with, but it could be the seed of something bigger to come. ")]), _c('a', {
    attrs: {
      "id": "id_23"
    }
  }, [_vm._v("“The focus,” Dr. Mithoefer says, is on “tackling the affected partner’s PTSD and addressing issues it may have created in the relationship.”")])]), _c('a', {
    attrs: {
      "id": "id_23"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_23"
    }
  }, [_vm._v("It is a good place to start. But not all relationship problems stem from full-blown mental illness. Could MDMA-assisted counseling be helpful for a wider range of issues in the not-too-distant future? We tackle that question in detail later in this book. For now, the focus is on treating the most devastating of psychiatric conditions, an approach that is winning over crucial gatekeepers in the government. ")]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("In fact, during the same year the Mithoefers started their work with married couples, ")]), _c('a', {
    attrs: {
      "id": "id_24"
    }
  }, [_vm._v("MDMA was granted “breakthrough” status by the U.S. Food and Drug Administration, one of the nation’s top health and safety watchdogs.")])]), _c('a', {
    attrs: {
      "id": "id_24"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_24"
    }
  }), _c('a', {
    attrs: {
      "id": "id_25"
    }
  }, [_vm._v("The following year, a phase 2 clinical trial was published in "), _c('em', [_vm._v("The Lancet Psychiatry")]), _vm._v(", reporting that MDMA-supported psychotherapy was effective at reducing symptoms of PTSD in a small sample of war veterans and first responders. A much larger, phase 3 trial is now underway. ")]), _c('a', {
    attrs: {
      "id": "id_26"
    }
  }, [_vm._v("As for safety, the accumulated evidence suggests that short-term, limited use of MDMA—with professional supervision in a comfortable, therapeutic environment—carries a low risk of physical or psychological harm. The reputation of MDMA as a dangerous party drug is melting away with each carefully conducted study.")])]), _c('a', {
    attrs: {
      "id": "id_26"
    }
  }, [_c('p', {
    staticClass: "C126"
  }, [_c('strong', [_vm._v("Early days")])])]), _c('p', {
    staticClass: "P25"
  }, [_c('a', {
    attrs: {
      "id": "id_26"
    }
  }, [_vm._v("When we started our work almost a decade ago, MDMA was still mostly known as a legally forbidden shortcut to dance floor euphoria. ")]), _c('a', {
    attrs: {
      "id": "id_27"
    }
  }, [_vm._v("And the risk of serious harm in such contexts "), _c('em', [_vm._v("is")]), _vm._v(" much greater than in therapeutic settings—up to and including death, as we will see. As an additional hurdle, our proposal that MDMA might one day be used as an aid in couples counseling, including for clients without a psychiatric disorder, was not so obviously within the realm of conventional medicine as a cure for PTSD. So our "), _c('em', [_vm._v("Atlantic")]), _vm._v(" interview turned some heads: two ethicists (of all people) from a conservative old British university (of all places) talking publicly about the potential nonmedical benefits of a currently illegal drug. It wasn’t what people expected.")])]), _c('a', {
    attrs: {
      "id": "id_27"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_27"
    }
  }, [_vm._v("But it shouldn’t have been so surprising. After all, the question of whether a drug, or anything, should be illegal in the first place "), _c('em', [_vm._v("is")]), _vm._v(" an ethical question, and current laws are not always adequately justified. The same goes for the lines that get drawn between “medical” and “nonmedical” substances. Whether we call a drug medicine, or regard it as a form of recreation, or try to harness its effects to improve our lives (what we refer to in this book as enhancement), ")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("it makes no difference to the molecules in question. They work on the brain however they work, and produce whatever effects they produce—good, bad, both, or in-between.")])]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "id_28"
    }
  }, [_vm._v("Often the legal or medical status of a drug has more to do with quirks of history or politics than with a sound understanding of its actual benefits and risks. Does a drug-induced mood-lift count as medicine? If you suffer from depression and got the drug from your doctor, yes. If you don’t suffer from depression and got the drug from your dealer, no. But the boundaries are blurrier than they first appear. In this book, we will explore the ethics of using drugs for "), _c('em', [_vm._v("relationship enhancement")]), _vm._v(", breaking out of the individual-centered, disease-focused model of modern medicine. In short, we will argue that if drug-assisted couples counseling can truly help improve people’s relationships, then there should in principle be a way for them to access that experience. And psychiatrists shouldn’t have to first make up a raft of “relationship disorders” so that the experience can qualify as medical treatment.")])]), _c('a', {
    attrs: {
      "id": "id_28"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("If our claim is justified in principle, what about in practice? A lot depends on the details and on the implications for society. Widespread changes in patterns of drug use or modes of access could have rippling consequences, both positive and negative, many of which would be hard to predict. That is why we need to have this conversation. But whether or not our specific proposal catches on, there are already signs that society is on the fast track to a drug revolution. We think it will start with greater acceptance of mind-altering substances as treatments for recognized psychiatric disorders, like PTSD. It will move from there to the use of such substances to help people in general improve their lives and relationships from whatever psychological baseline they happen to be at—including some that would now be considered healthy or normal.")]), _vm._v(" "), _c('p', {
    staticClass: "C67"
  }, [_vm._v("♥ ♥ ♥")])]), _c('p', {
    staticClass: "P25"
  }, [_c('a', {
    attrs: {
      "id": "id_28"
    }
  }, [_vm._v("Evidence for this second revolutionary phase is building. One lead comes from the broad success of ")]), _c('a', {
    attrs: {
      "id": "id_29"
    }
  }, [_vm._v("journalist Michael Pollan’s recent ")]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("meditation on psychedelics, "), _c('em', [_vm._v("How to Change Your Mind")]), _vm._v(". With lessons for “consciousness, dying, addiction, depression, and transcendence” promised in the subtitle—and thoughtfully delivered—the book is not just being touted by aging hippies and panned by everyone else. Instead, it has touched a nonpartisan nerve, as people from every corner of social, professional, and political life are showing a cautious open-mindedness about mind-opening drugs.")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Another recent lead is a 2018 study conducted by Roland Griffiths, the respected Johns Hopkins University neuroscientist and drug researcher, which looked at the effects of psilocybin (the active ingredient in magic mushrooms) combined with meditation in healthy volunteers. ")]), _c('a', {
    attrs: {
      "id": "id_30"
    }
  }, [_vm._v("The results, published in the "), _c('em', [_vm._v("Journal of Psychopharmacology")]), _vm._v(", suggest “enduring positive changes in psychological functioning and in trait measures of prosocial attitudes and behaviors.” No disease or disorder here—just ordinary people seeking positive change.")])]), _c('a', {
    attrs: {
      "id": "id_30"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("Griffiths and his collaborators believe that under appropriately supportive conditions, psilocybin can “reliably occasion deeply personally meaningful and often spiritually significant experiences.” Neither of us is particularly “spiritual,” but we have contributed to academic and public debates about the ethics of human enhancement, and we see some overlap between the two ideas. Unless you view the human condition as one big disease state (which seems like a stretch), attempts to improve yourself “spiritually” are not premised on being ill. Whether it’s meditation, hiking in the mountains, practicing yoga, or using psychedelics under the right conditions, spiritual practices meet you where you are and aim to get you somewhere better. The same is true of biomedical enhancement: the use of drugs or other technologies to improve so-called normal human traits and abilities.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_30"
    }
  }, [_vm._v("Seen in this light, our habit of categorizing drugs as either medical or recreational might seem a bit myopic. Some drugs that are used for recreation are risky and addictive, and often make people’s lives much worse. Alcohol is a good example. ")]), _c('a', {
    attrs: {
      "id": "id_31"
    }
  }, [_vm._v("Some drugs that are ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("used for medicine, like prescription opioids, follow the same basic outline. ")]), _c('a', {
    attrs: {
      "id": "id_33"
    }
  }, [_vm._v("But other drugs that are used for recreation (and now increasingly for medicine), like MDMA and psilocybin, are less risky, generally nonaddictive, and can help make people’s lives much better. In our view, when a drug has this potential—to improve people’s lives if used in the right way—it shouldn’t matter so much whether we call it medicine or something else. The important thing is to learn how it works, to understand its effects, both good and bad, and to clarify the conditions for individuals, relationships, and society under which it brings more benefit than harm.")])]), _c('a', {
    attrs: {
      "id": "id_33"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("Something like this view is catching on. People are starting to realize that not all drugs are “bad” and that you don’t necessarily need to have a disease or disorder for a chemical substance to help improve your life. In this book, we explore whether drugs can ethically be used to enhance that aspect of our lives we often care about the most: our romantic relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "C126"
  }, [_c('strong', [_vm._v("Love, drugs, and marriage")])])]), _c('p', {
    staticClass: "P25"
  }, [_c('a', {
    attrs: {
      "id": "id_33"
    }
  }, [_vm._v("“How LSD Saved One Woman’s Marriage.” ")]), _c('a', {
    attrs: {
      "id": "id_32"
    }
  }, [_vm._v("That’s another headline from the "), _c('em', [_vm._v("New York Times")]), _vm._v(". ")]), _c('a', {
    attrs: {
      "id": "id_35"
    }
  }, [_vm._v("The reference is to a self-experiment with the drug colloquially known as acid by novelist Ayelet Waldman, as recounted in her memoir, "), _c('em', [_vm._v("A Really Good Day: How Microdosing Made a Mega Difference in My Mood, My Marriage, and My Life")]), _vm._v(". Microdosing refers to a practice now popular among Silicon Valley types of taking a tenth or so of a regular dose of a psychedelic substance on a somewhat consistent basis (say, every few days). ")]), _c('a', {
    attrs: {
      "id": "id_34"
    }
  }, [_vm._v("The effects are supposed to be subperceptual: not enough to cause a full-blown trip but enough to feel “sparkly,” as one writer put it. And enough, apparently, to bring a troubled relationship back from the brink.")])]), _c('a', {
    attrs: {
      "id": "id_34"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_34"
    }
  }), _c('a', {
    attrs: {
      "id": "id_37"
    }
  }, [_vm._v("“I was suffering,” Waldman writes. “Worse, I was making the people around me suffer. I was in pain, and I was desperate and it suddenly seemed like I had nothing to lose.” The way Waldman describes herself and her behavior before her microdosing experiment ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("is not flattering. She would frequently pick fights with her husband for no apparent reason, and then berate herself for having done it. ")]), _c('a', {
    attrs: {
      "id": "id_36"
    }
  }, [_vm._v("Her frustration would then compel her to lash out again, making her even more despondent—“my shame spiral screwing a hole right through our relationship.” Once she started microdosing every third day, she says, she found herself becoming a better listener, calmer and more content, less prone to conflict, more productive, less irritable, more flexible, more affectionate, and more mindful. Not surprisingly, all of this was positive for her marriage.")])]), _c('a', {
    attrs: {
      "id": "id_36"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_36"
    }
  }, [_vm._v("Waldman had a good experience. But there is reason for skepticism when you are dealing with a single account. ")]), _c('a', {
    attrs: {
      "id": "id_38"
    }
  }, [_vm._v("Not only can microdosing land you in jail (it’s illegal), but there are currently no good scientific data on the benefits and risks of this habit, or even how it differs from a sugar-pill placebo. Anecdotes are not enough. What we need is careful research: certainly, the empirical kind associated with lab coats and clinical trials, but also ethical and sociological studies to make sense of the moral and cultural dimensions of drug-enhanced modes of living and being.")])]), _c('a', {
    attrs: {
      "id": "id_38"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_38"
    }
  }, [_vm._v("Drug-assisted breakups may also soon be a possibility. ")]), _c('a', {
    attrs: {
      "id": "id_39"
    }
  }, [_vm._v("One of us (Brian) received an e-mail the other day from a total stranger, written in an Eastern European language. With the help of Google Translate, Brian got into a back-and-forth with his impromptu correspondent, a despondent housewife as it soon became clear. We’ll call her Sofia. A heartbreaking picture emerged. Sofia was clearly desperate and seemed to be in a bad situation. She couldn’t live with her husband, she said, because he was oppressive and misogynistic. But she couldn’t leave him either, because despite all that, she loved him—really loved him—and the thought of splitting up made her despair.")])]), _c('a', {
    attrs: {
      "id": "id_39"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("Sofia knew she needed to get out of the relationship, but her heart kept saying no. So she reached out to us for a remedy, some kind of “cure for love,” as she put it, that would vanquish her feelings of attachment to her spouse. Freed from the bonds of a love gone bad, she might then try to start her life over with someone else. She was requesting what we call in our work an “anti-love drug.”")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_39"
    }
  }), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Suppose Sofia took such a drug. Could it really make her fall out of love? Partly, this depends on how the drug would work—how exactly it would act on her brain, what side effects it might have, and how it would affect her thoughts and feelings. But it also depends on a deeper, philosophical question we will be grappling with throughout this book: namely, what it actually means to "), _c('em', [_vm._v("be")]), _vm._v(" in love (much less fall out of it). ")]), _c('a', {
    attrs: {
      "id": "id_40"
    }
  }, [_vm._v("Some would argue that Sofia couldn’t have been experiencing real love, because she was in an oppressive relationship. ")]), _c('a', {
    attrs: {
      "id": "id_41"
    }
  }, [_vm._v("This is a normative definition of love: it says that the very concept should be reserved for relationships that are essentially positive, good, or healthy. Since love is a highly valued phenomenon, this perspective goes, we should take a moral stand on what sorts of things get to count as love in the first place. ")]), _c('a', {
    attrs: {
      "id": "id_42"
    }
  }, [_vm._v("If the feelings between individuals in a harmful or abusive relationship are described as love, the worry is that it might legitimize, or provide cover for, the abuse.")])]), _c('a', {
    attrs: {
      "id": "id_42"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_42"
    }
  }, [_vm._v("It’s a compelling argument. We have no problem with people who want to use “love” in this restricted way. But it’s a risky argument as well. ")]), _c('a', {
    attrs: {
      "id": "id_43"
    }
  }, [_vm._v("Once we start defining for other people what love is, even overriding their personal judgments, we can slip into a narrow-minded and paternalistic way of thinking that discounts their lived experiences. This is not just an academic concern. Only a few decades ago (and in many places still today) it was commonly held that love between same-sex partners was a conceptual impossibility, a mistake in thought and language, since "), _c('em', [_vm._v("real")]), _vm._v(" love could only occur between a man and a woman. For a depressing illustration of this attitude, look up the YouTube video “Christopher Hitchens vs. Bill Donohue.” ")]), _c('a', {
    attrs: {
      "id": "id_44"
    }
  }, [_vm._v("Then listen to the incredulous groaning and laughter from the audience when Hitchens makes the claim that homosexuality can be a form of love. That debate took place in 2000 in New York City. Not so long ago, and not in some far-off kingdom.")])]), _c('a', {
    attrs: {
      "id": "id_44"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_44"
    }
  }, [_vm._v("The point is that normative definitions of love often favor the group in power, and their perspective is not always justified—even if they have good intentions. ")]), _c('a', {
    attrs: {
      "id": "id_46"
    }
  }, [_vm._v("The tendency to “medicalize” love and say that it only really counts if it’s “healthy” may be an example of ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("this. An alternative approach, which is broadly the one we take in this book, would be to opt for a more neutral or descriptive route, giving wide berth to individuals to feel and conceive of love in their own way. When we are talking about people’s romantic experiences, then, we will mostly avoid couching them in thick theoretical terms or trying to show how they link up to the latest philosophical account of love. That is, we’ll often use the word “love” in an informal way and let you fill in the relevant sense according to the context and your own intuitions. And in a similar vein, when we tell you stories about individuals who claim to be in love, we will let them speak for themselves and try to take them at their word.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Some philosophical accounts of love actually support this approach. One of them, defended by the Danish American philosopher Berit Brogaard, says that love is, first and foremost, an emotion: a subjective, conscious, relational feeling that persists through various circumstances and lengths of time which only "), _c('em', [_vm._v("you")]), _vm._v(", the individual, can directly access. In other words, barring special circumstances like obvious delusion, if you sincerely believe you are in love with someone, then you are. ")]), _c('a', {
    attrs: {
      "id": "id_45"
    }
  }, [_vm._v("One implication of this account, including for the situation with Sofia, is that it "), _c('em', [_vm._v("is")]), _vm._v(" possible to truly love someone who is not good to you or who even hurts or abuses you. It’s just that this love may be so foolish, harmful, or irrational that you have reason to make it go away—with or without the use of a drug.")])]), _c('a', {
    attrs: {
      "id": "id_45"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_45"
    }
  }), _c('a', {
    attrs: {
      "id": "id_47"
    }
  }, [_vm._v("Another prominent theory says that love has two dimensions, a "), _c('em', [_vm._v("dual nature")]), _vm._v(". This theory tries to get beneath the emotions we feel when we’re in love, and explain where they come from and how they work. The first dimension is biological. ")]), _c('a', {
    attrs: {
      "id": "id_48"
    }
  }, [_vm._v("It acknowledges that our capacity for love is deeply rooted in our evolutionary history, reflecting basic human drives for sex and attachment. These drives promote our continuation as a species, motivate us to care for vulnerable offspring, and fill a deep survival need for unconditional support. The other dimension is psychosocial and historical. It speaks to the cultural norms, social pressures, and ideological constraints that exist ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("at a given place and time and shape how we think about, experience, and express romantic love in our daily lives.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("We will get into this dual-nature theory in the next chapter. We bring it up now to make a point about Sofia. If love, including romantic love, really does have a dual nature, both biological and psychosocial, then it might be possible to "), _c('em', [_vm._v("change")]), _vm._v(" love along one or both dimensions. Take the psychosocial aspect first. ")]), _c('a', {
    attrs: {
      "id": "id_49"
    }
  }, [_vm._v("One way Sofia could try to dissolve her feelings of attachment to her abusive partner would be to intervene in this domain. She could seek support from friends and family, affirm her own self-worth, and deliberately dwell on her husband’s evident faults and failings. Talking to an experienced relationship therapist, if she could find one, would also be a good idea.")])]), _c('a', {
    attrs: {
      "id": "id_49"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("Indeed, she "), _c('em', [_vm._v("should")]), _vm._v(" do those things. If it is right for a relationship to end, then pulling social and psychological levers to create emotional distance and open up a space for healing is indispensable: a drug should never be used as a replacement for these measures. But sometimes these measures will not be enough. Sometimes attachment runs so deep, and is so hard to break, that a person cannot effectively make these changes even when they know they should.")]), _vm._v(" "), _c('p', {
    staticClass: "P26"
  }, [_vm._v("This is where biology comes in. If it becomes possible to safely target the underlying neurochemistry that supports romantic attachment, using drugs or other brain-level technologies, then there is reason to think this could help some people who really need it. At the very least, we claim, there is reason to look into this possibility given the stakes involved. And if it does turn out to be possible, what then? We would need to determine the ethical limits for using such drugs and decide what legal and policy structures would have to be put in place to guide their responsible use.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_49"
    }
  }, [_vm._v("These challenges come to the fore in later chapters. But at no point do we advocate the use of biotechnology as a quick fix for relationship troubles. Nor do we think such technology should be used illegally, coercively, or at home in isolation. Instead, we consider the voluntary use of biochemical agents in conjunction with professional ")]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("psychotherapy, social support, and other established strategies as a way to help people achieve their relationship goals.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "C126"
  }, [_c('strong', [_vm._v("Brave new love?")])])]), _c('p', {
    staticClass: "P25"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Even with these caveats, some readers may be grinding their teeth at the very idea of combining drugs and relationships (or maybe not; the title of this book is not subtle). The last thing we need, they might think, is another excuse for pharmaceutical companies, or the medical-industrial complex more generally, to colonize another aspect of our lives. ")]), _c('a', {
    attrs: {
      "id": "id_50"
    }
  }, [_vm._v("Or maybe they see parallels with Aldous Huxley’s fictional drug “soma” in the dystopian "), _c('em', [_vm._v("Brave New World")]), _vm._v(" (the original working title for our book was "), _c('em', [_vm._v("Brave New Love")]), _vm._v("). ")]), _c('a', {
    attrs: {
      "id": "id_51"
    }
  }, [_vm._v("As an online commenter wrote in response to a piece about our work: “Shall we call it denial in a bottle? This is a horrible idea, you can’t fix everything with a happy pill. I thought we had already established this.”")])]), _c('a', {
    attrs: {
      "id": "id_51"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_51"
    }
  }, [_vm._v("The commenter is making an important point. There are many legitimate concerns that could be raised about the romantic version of a happy pill, and we will look at those concerns and take them seriously. But it won’t be enough to just catalogue objections and call it a day. ")]), _c('a', {
    attrs: {
      "id": "id_52"
    }
  }, [_vm._v("Whenever society is faced with some new biochemical or technological possibility, we have to think carefully, not just about the potential costs and dangers of making it a reality but also about the potential benefits it could provide if used responsibly and managed effectively. Throughout this book, we will highlight cases where we think love-affecting biotechnology could be genuinely helpful in promoting people’s welfare or reducing their unbearable suffering. We’ll also spell out a number of boundary conditions for when such drugs should "), _c('em', [_vm._v("not")]), _vm._v(" be used for various reasons.")])]), _c('a', {
    attrs: {
      "id": "id_52"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_52"
    }
  }, [_vm._v("These drugs are not science fiction. In the case of Sofia, there are existing medications she could use off-label—that is, for something other than their intended purpose—to dull her feelings of attachment today. We have also mentioned MDMA, which might at first seem like a pro-love drug, or something that inevitably draws people closer ")]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("together. For an abusive relationship, that could spell disaster. But as we will see, MDMA is not quite as simple as that. It isn’t just an emotional glue that cements people’s hearts together no matter how incompatible they may be. Sometimes it can help a person realize that a relationship needs to end, and that the sheer fear of change has been holding them back. As we mentioned, MDMA is now being tested as a treatment for individual-level mental health issues. Are the scientists behind these trials even asking about the drug’s effects on relationships? With the exception of the Mithoefers, for the most part, no. But they should be.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("This lesson applies to drugs used for medicine in general. Overwhelmingly, such drugs are used to treat problems faced by an individual, not problems that exist within a romantic partnership. Seeing the limitations of this approach, some psychiatrists have started to get creative with diagnostic categories. One of them, whom we’ll meet in a later chapter, has devised a way to prescribe medication for the treatment of "), _c('em', [_vm._v("jealousy")]), _vm._v(". This is not something that is normally seen as a medical condition, although unfounded or excessive jealousy can of course do serious damage to an otherwise good relationship.")])]), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("There is some evidence that drug-based treatments for obsessive-compulsive disorder may also help with destructive jealousy (a fact the psychiatrist took careful note of). But it’s all a bit touch and go. This book argues that we should study the implications not just of currently illicit drugs like MDMA, but also of common, legal, prescription medications that are already affecting our relationships—only in ways we don’t fully recognize. ")]), _c('a', {
    attrs: {
      "id": "id_53"
    }
  }, [_vm._v("This is a blind spot in Western medicine: the tendency to ignore the interpersonal effects of drug-based interventions. Hormonal birth control is a key example in this area; antidepressants and antianxiety drugs are as well. It should be a scandal that we don’t know more about the effects of these drugs (good or bad) on our romantic partnerships, due to an exclusive focus on individuals and their private symptoms in clinical studies. ")]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("How can scientific research norms be overhauled to take "), _c('em', [_vm._v("relationships")]), _vm._v(" more fully into account?")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("The time to think through such questions is now. Biochemical interventions into love and relationships are not some far-off speculation. Our most intimate connections are already being influenced by drugs we ingest for other purposes. ")]), _c('a', {
    attrs: {
      "id": "id_54"
    }
  }, [_vm._v("Controlled studies are already underway to see whether artificial brain chemicals might enhance the positive effects of couples therapy. And as later chapters will explore, fundamentalist religious groups are already experimenting with certain medications to quash romantic desires—even the urge to masturbate—among children and vulnerable sexual minorities.")])]), _c('a', {
    attrs: {
      "id": "id_54"
    }
  }), _c('p', {
    staticClass: "P26"
  }, [_c('a', {
    attrs: {
      "id": "id_54"
    }
  }, [_vm._v("Simply put, the horse has bolted. Where it runs is up to us. Some may fear the advent of relationship-affecting neurotechnologies and do everything they can to prevent their further development. ")]), _c('a', {
    attrs: {
      "id": "id_55"
    }
  }, [_vm._v("Others may think that in the future doctors will have a moral responsibility to chemically help patients with relationships and love. Others may fall somewhere in the middle.")])]), _c('a', {
    attrs: {
      "id": "id_55"
    }
  }, [_c('p', {
    staticClass: "P26"
  }, [_vm._v("Love and its effects touch all of us. So each of us must decide where we stand in this debate. The goal of this book is to arm you with the latest scientific knowledge and a set of ethical tools you can use to decide for yourself whether love drugs—or anti-love drugs—should be a part of our society. Or whether a chemical romance might be right for you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493074df","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_1__Revolution.vue
// module id = 75
// module chunks = 0